"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = exports.ArticleType = exports.ModelType = exports.ConversationMessageType = void 0;
var ConversationMessageType;
(function (ConversationMessageType) {
    ConversationMessageType["UNKOWN"] = "UNKOWN";
    ConversationMessageType["AGENT"] = "AGENT";
    ConversationMessageType["USER"] = "USER";
})(ConversationMessageType = exports.ConversationMessageType || (exports.ConversationMessageType = {}));
var ModelType;
(function (ModelType) {
    ModelType["UNKOWN"] = "UNKOWN";
    ModelType["TEXT_DAVINCI_003"] = "TEXT_DAVINCI_003";
    ModelType["TEXT_CURIE_001"] = "TEXT_CURIE_001";
    ModelType["TEXT_BABBAGE_001"] = "TEXT_BABBAGE_001";
    ModelType["TEXT_ADA_001"] = "TEXT_ADA_001";
    ModelType["GPT_3_5_TURBO"] = "GPT_3_5_TURBO";
})(ModelType = exports.ModelType || (exports.ModelType = {}));
var ArticleType;
(function (ArticleType) {
    ArticleType["UNKNOWN"] = "UNKNOWN";
    ArticleType["ARTICLE"] = "ARTICLE";
    ArticleType["FEATURE_REQUEST"] = "FEATURE_REQUEST";
    ArticleType["KNOWN_ISSUE"] = "KNOWN_ISSUE";
    ArticleType["VIDEO"] = "VIDEO";
})(ArticleType = exports.ArticleType || (exports.ArticleType = {}));
var ContentType;
(function (ContentType) {
    ContentType["INTRO"] = "INTRO";
    ContentType["NOTE"] = "NOTE";
    ContentType["OTHER"] = "OTHER";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
//# sourceMappingURL=types.impl.js.map